import React from 'react';
import styled from 'styled-components';
import Player from './Player';
import VideoPlayer from './VideoPlayer';

const Wrapper = styled.div``;

const VideoLoop = styled.video`
  width: 100%;
  height: auto;
`;

const Video = ({ video, loop, loopWithSound, poster }) => {

  return (
    <Wrapper>
      {!loop || loopWithSound ? (
        <VideoPlayer src={video} playsInline preload loopWithSound={loopWithSound} poster={poster} />
      ) : (
        <VideoLoop muted loop autoPlay playsInline preload poster={poster && poster.url}>
          <source src={video} type={'video/mp4'} />
        </VideoLoop>
      )}
    </Wrapper>
  );
};

export default Video;
